<template>
  <div class="abs-autori" >

    <div class="row">
        <div class="col s3" v-if="false">
            <el-form-item >
                <el-input  v-model="autore.id"></el-input>
            </el-form-item>
        </div>
        <div class="col s5">
            <el-form-item :label="$teras.lang.cognome">
                <el-input  v-model="autore.cognome"></el-input>
            </el-form-item>
        </div>
        <div class="col s5">
            <el-form-item :label="$teras.lang.nome">
                <el-input  v-model="autore.nome"></el-input>
            </el-form-item>
        </div>
        <div class="col s2">&#160;</div>
       
    </div>

    <div class="row">
        <div class="col s10" >

          <el-form-item :label="$teras.lang.affiliazione" >
            <el-select v-model="autore.affiliazione" multiple style="width:100%">
              <el-option v-for="item in $teras.affiliazioni" :label="item.nome" :value="item.id" :key="item.id"></el-option>
            </el-select>  
          </el-form-item>
        </div>
         <div class="col s2">
            <el-tooltip v-if="autore.id==-1" class="item" effect="dark" :content="$teras.lang.aggiungi" placement="top"><el-button type="primary" icon="plus" @click="addNow"></el-button></el-tooltip>
            <el-tooltip v-if="autore.id>-1" class="item" effect="dark" :content="$teras.lang.salvamodifiche" placement="top"><el-button  type="success" icon="edit" @click="editNow"></el-button></el-tooltip>
            <el-tooltip v-if="autore.id>-1" class="item" effect="dark" :content="$teras.lang.cancella" placement="top"><el-button  type="danger" icon="delete" @click="delNow"></el-button></el-tooltip>
        </div>
    </div>

  <div class="row pad help" v-if="$teras.autori.length>0">
    <div class="col s2 yo-align-right"><i class="material-icons">live_help</i></div>
    <div class="col s10"  v-html="$teras.lang.autoriOrderHelp"></div>
  </div>

    <draggable :list="$teras.autori" class="dragArea" @end="onEnd" v-if="$teras.autori.length>0">
        <div v-for="(element, index) in $teras.autori" @click="onEdit(element)" :key="element.id">{{index+1}} {{element.cognome}} {{element.nome}} <sup>{{affiliazione(element.affiliazione)}}</sup></div>
    </draggable>


  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'abs-autori',
  components: {
    draggable
  },
  created () {
    console.log("Arrivo al abs-autori.vue");
  },
  data() {
    return {
      options: {},
      autore:{
        id:-1,
        cognome: '',
        nome: '',
        affiliazione:[]
      },
    }
  },
  computed:{
      

  },
  methods: {
    affiliazione(ids){
      var affiliazioni = []
      console.log('AFFILIAZIONI ++++++++++++++++++++++++++++++++++++')
      console.log(typeof ids)
      if(typeof ids === 'object')
      for ( const id of ids){

        for ( const affiliazione of this.$teras.affiliazioni){
            //console.log(affiliazione)
            if(affiliazione.id == id){
            affiliazioni.push( this.$teras.affiliazioni.indexOf(affiliazione)+1)
            }
        }
      }

      if(typeof ids === 'string')
       for ( const affiliazione of ids.split(',')){
            affiliazioni.push(parseInt(affiliazione)+1)
          
        }

      if(typeof ids === 'number')
       //for ( const affiliazione of ids.split(',')){
            affiliazioni.push(parseInt(ids)+1)
          
        //}



        return affiliazioni.join()
      },
    onEnd(){
    },
    onEdit(autore){
      this.autore.id=autore.id
      this.autore.cognome=autore.cognome
      this.autore.nome=autore.nome
      if(typeof autore.affiliazione === 'string'){
        this.autore.affiliazione=autore.affiliazione.split(',').map(Number)
        console.log(autore.affiliazione.split(',').map(Number))
      }else if(typeof autore.affiliazione === 'number'){
        this.autore.affiliazione=[autore.affiliazione]
      }else{
        this.autore.affiliazione=autore.affiliazione
      }
      console.log("MODIFICO")
      console.log(autore)
      console.log(this.$teras.autori)
    },
    delNow(){
      for ( const autore of this.$teras.autori){
        //console.log(autore)
        if(autore.id == this.autore.id){
          console.log(this.$teras.autori.indexOf(autore))
          this.$teras.autori.splice(this.$teras.autori.indexOf(autore),1)
          this.reset()
        }
      }
    },
    addNow(){
      this.autore.id = this.$teras.autori.length
      this.$teras.autori.push({id:this.autore.id,cognome:this.autore.cognome,nome:this.autore.nome,affiliazione:this.autore.affiliazione})
      this.reset()
      if(this.$teras.abs.pa=-1){
        this.$teras.abs.pa=0
      }
    },
    editNow(){
      for (let autore of this.$teras.autori)
        if(autore.id == this.autore.id){
          autore.cognome=this.autore.cognome
          autore.nome=this.autore.nome
          autore.affiliazione=this.autore.affiliazione
        }
      this.reset()
    },
    reset(){
      this.autore.id=-1
      this.autore.cognome=''
      this.autore.nome=''
      this.autore.affiliazione = []
    }
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// Abs-autori.vue?df91fd96